export { default as AddPageFormLayout } from './AddPageFormLayout';
export { default as StepFields } from './step-fields';
export { default as StepMeta } from './step-meta';
export { default as AddPageFormStep1 } from './step1';
export { default as AddPageFormStep2 } from './step2';
export { default as AddPageFormStep3 } from './step3';
export { default as AddPageFormStep4 } from './step4';
export { default as AddPageFormStep5 } from './step5';
export { default as VideoStyleItem } from './step5/video-style-item';
export * from './svg';
export * from './template';

